export default __webpack_public_path__ + "static/media/regreenbus_info_con_02.6bb9821b.png";